<div class="contest-leaderboard-head mobile-v">
    <div class="mobile-back-btn" onclick="history.back()">
        <span class="mr-2"><img src="../../../assets/img/contests/left-icon.svg" alt=""></span> Back
     </div> 
</div>

<div class="wc-table-wrapper">
    <div class="table-section">
        <div class="container text-center">
            <div class="box transaction-box ">
                <div class="header-container">  
                    <div class="contest-leaderboard-head desktop-version">
                        <div class="mobile-back-btn" onclick="history.back()">
                            <span class="mr-2"><img src="../../../assets/img/contests/left-icon.svg" alt=""></span> Back
                         </div> 
                    </div>
                </div>
                <div class="c-headline contest-player-details">
                    <h3 class="section-header">Match Stats</h3>
                    <div class="date" >
                        <span class="icon">
                            <img src="../../../assets/img/contests/date.svg" alt="">
                        </span>
                        {{contestMatchStatistics?.matchDate|date:'MMMM d, y, h:mm a'}}
                    </div>
                    <div *ngIf="contestMatchStatistics?.tournamentMatchStatus !== 'notstarted'" class="l-wrapper mt-2" id="wrapper">
                        <span class=" chip-div c-chip c-chip--success" *ngIf="contestMatchStatistics?.tournamentMatchStatus === 'inprogress'">In
                            Progress</span>
                        <span class=" chip-div c-chip c-chip--success" *ngIf="contestMatchStatistics?.tournamentMatchStatus === 'notstarted'">Match Not
                            Started</span>
                            <span class=" chip-div c-chip c-chip--success" *ngIf="contestMatchStatistics?.tournamentMatchStatus === 'finished' && !contestMatchStatistics?.prizeDistributionDone">In Review</span>
                        <span class="chip-div c-chip c-chip--success" *ngIf="contestMatchStatistics?.tournamentMatchStatus === 'finished' && contestMatchStatistics?.prizeDistributionDone">Completed</span>
                        <span class="chip-div c-chip c-chip--success" *ngIf="contestMatchStatistics?.tournamentMatchStatus === 'canceled'">
                            Canceled</span>
                    </div>

                    <div *ngIf="contestMatchStatistics?.tournamentMatchStatus === 'notstarted'" class="l-wrapper" id="wrapper">
                        <span class="c-chip c-chip--success chip-div">Yet to Start</span>
                    </div>
                        <div class="main-contest-image-div" [ngClass]="(isContestDoubles) ? 'double-contest-main-div' : 'single-contest-main-div' ">
                            <div class="players-main-parent-div first single-div" *ngIf="!isContestDoubles">
                                <div class="palyer-main-details"  >
                                    <div class="main-player-div">
                                        <!-- <img src="{{contestDetails?.player1Image}}" alt="" class="single-div"> -->
                                        <img *ngIf="contestMatchStatistics?.player1Image" class="single-div" src="{{contestMatchStatistics?.player1Image}}">
                                        <img *ngIf="!contestMatchStatistics?.player1Image" class="single-div" src="https://devapi.tplsport.com:4600/uploads/images/profile.jpg">
            
                                    </div>
                                        <div class="main-details details">
                                            <span class="palyer-name">
                                                {{ (contestMatchStatistics?.player1Name) ? contestPlayerName(contestMatchStatistics?.player1Name) : '' }}
                                            </span>
                                            <span class="vs-tag">Vs</span>
                                            <span class="palyer-name">
                                                {{ (contestMatchStatistics?.player2Name) ? contestPlayerName(contestMatchStatistics?.player2Name) : '' }}
                                            </span>
                                        </div>
                                    <div class="main-player-div">
                                    
                                        <img *ngIf="contestMatchStatistics?.player2Image" class="single-div" src="{{contestMatchStatistics?.player2Image}}">
                                        <img *ngIf="!contestMatchStatistics?.player2Image" class="single-div" src="https://devapi.tplsport.com:4600/uploads/images/profile.jpg">
                                    </div>
                                </div>
                               
                              </div>
                              <div class="players-main-parent-div first single-div" *ngIf="isContestDoubles">
                                <div class="palyer-main-details"  >
                                    <div class="double-player-div">
                                        <div class="main-player-div">
                                            <!-- <img src="{{contestDetails?.player1Image}}" alt="" class="single-div"> -->
                                            <img *ngIf="contestMatchStatistics?.player1Image" class="single-div" src="{{contestMatchStatistics?.player1Image}}"> 
                                            <img *ngIf="!contestMatchStatistics?.player1Image" class="single-div" src="https://devapi.tplsport.com:4600/uploads/images/profile.jpg"> 
                                        </div>
                                        
                                    </div>
                                
                                        <div class="main-details details">
                                            <span class="palyer-name">
                                                {{ (contestMatchStatistics?.player1Name) ? contestPlayerName(contestMatchStatistics?.player1Name) : '' }}
                                            </span>
                                            <span class="vs-tag">Vs</span>
                                            <span class="palyer-name">
                                                {{ (contestMatchStatistics?.player2Name) ? contestPlayerName(contestMatchStatistics?.player2Name) : '' }}
                                            </span>
                                        </div>
                                        <div class="double-player-div">
                                            <div class="main-player-div"> 
                                                <img *ngIf="contestMatchStatistics?.player2Image" class="single-div" src="{{contestMatchStatistics?.player2Image}}"> 
                                                <img *ngIf="!contestMatchStatistics?.player2Image" class="single-div" src="https://devapi.tplsport.com:4600/uploads/images/profile.jpg">
                                            </div>
                                            
                                        </div>
                                    
                                </div>
                               
                              </div>

                              
                        </div>
                   
                 
                </div>
                <div class="players-main-parent-div second">
                    <div class="palyer-main-details">
                        <div class="main-player-div hidden">
                            <!-- <img src="{{contestDetails?.player1Image}}" alt="" class="single-div"> -->
                            <!-- <img *ngIf="contestMatchStatistics?.player1Image" class="single-div" src="{{contestMatchStatistics?.player1Image}}">
                            <img *ngIf="!contestMatchStatistics?.player1Image" class="single-div" src="https://devapi.tplsport.com:4600/uploads/images/profile.jpg"> -->

                        </div>

                        <div class="main-details details">
                                
                                <span class="palyer-name">
                                    <h6 class="h6">{{contestMatchStatistics?.tournamentName}} ({{ contestMatchStatistics?.tournamentCategoryName }})</h6>
                                </span>
                               
                            </div>
                        <div class="main-player-div hidden ">
                        
                            <img *ngIf="contestMatchStatistics?.player2Image" class="single-div" src="{{contestMatchStatistics?.player2Image}}">
                            <img *ngIf="!contestMatchStatistics?.player2Image" class="single-div" src="https://devapi.tplsport.com:4600/uploads/images/profile.jpg">
                        </div>
                    </div>
                   
                  </div>
                  
                
            
            <!-- <div class="row d-flex justify-content-center">
                <div class="col-4">
                    <img *ngIf="contestMatchStatistics?.player1Image" class="playerImage" src="{{contestMatchStatistics?.player1Image}}">
                    <img *ngIf="!contestMatchStatistics?.player1Image" class="playerImage" src="https://devapi.tplsport.com:4600/uploads/images/profile.jpg">
                </div>
                <div class="col-4">
                    <div *ngIf="contestMatchStatistics?.tournamentMatchStatus !== 'notstarted'" class="l-wrapper" id="wrapper">
                        <span class="c-chip c-chip--success" *ngIf="contestMatchStatistics?.tournamentMatchStatus === 'inprogress'">In
                            Progress</span>
                        <span class="c-chip c-chip--success" *ngIf="contestMatchStatistics?.tournamentMatchStatus === 'notstarted'">Match Not
                            Started</span>
                            <span class="c-chip c-chip--success" *ngIf="contestMatchStatistics?.tournamentMatchStatus === 'finished' && !contestMatchStatistics?.prizeDistributionDone">In Review</span>
                        <span class="c-chip c-chip--success" *ngIf="contestMatchStatistics?.tournamentMatchStatus === 'finished' && contestMatchStatistics?.prizeDistributionDone">Completed</span>
                        <span class="c-chip c-chip--success" *ngIf="contestMatchStatistics?.tournamentMatchStatus === 'canceled'">
                            Canceled</span>
                    </div>

                    <div *ngIf="contestMatchStatistics?.tournamentMatchStatus === 'notstarted'" class="l-wrapper" id="wrapper">
                        <span class="c-chip c-chip--success">Yet to Start</span>
                    </div>

                    <span class="fs-6">{{ (contestMatchStatistics?.player1Name) ? contestPlayerName(contestMatchStatistics?.player1Name) : '' }}</span> VS
                    <span class="fs-6">{{ (contestMatchStatistics?.player2Name) ? contestPlayerName(contestMatchStatistics?.player2Name) : '' }}</span>
                    <h6 class="h6">{{contestMatchStatistics?.tournamentName}} ({{ contestMatchStatistics?.tournamentCategoryName }})</h6>
                </div>
                <div class="col-4">
                    <img *ngIf="contestMatchStatistics?.player2Image" class="playerImage" src="{{contestMatchStatistics?.player2Image}}">
                    <img *ngIf="!contestMatchStatistics?.player2Image" class="playerImage" src="https://devapi.tplsport.com:4600/uploads/images/profile.jpg">
                </div>
            </div> -->

            <div class="row my-3 score-board-main">
                <div class="col-12 main-col">
                    <table>
                        <thead>
                            <tr class="head" style="background-color: #20b033; color: #ffff;">
                                <th colspan="7">
                                    <div class="row">
                                        <div class="col-12 table-heading">
                                            <span>SCORE</span>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style="background-color: #232323;color: #ffff;">
                            <tr>
                                <td class="name-player"><span class="fs-6 fw-bold">{{(contestMatchSetPointsStats?.awayTeam?.name) ? contestPlayerName(contestMatchSetPointsStats?.awayTeam?.name) : ''}}</span></td>
                                <td class="main-score-din-inside">
                                    <tr>
                                        <td *ngFor="let point of setPoints; let i=index" class="mai-table">
                                            <div class="card m-1 d-flex justify-content-center" >{{ (contestMatchSetPointsStats?.awayScore['period'+(i+1)] || contestMatchSetPointsStats?.awayScore['period'+(i+1)] >= 0) ? contestMatchSetPointsStats?.awayScore['period'+(i+1)] : '-' }}</div>
                                        </td>
                                    </tr>
                                </td>
                             
                                <td style="border-left: 1px solid lightgray;">
                                    <div class="card mx-3 d-flex justify-content-center" >{{ (contestMatchSetPointsStats?.awayScore?.current || contestMatchSetPointsStats?.awayScore?.current >= 0) ? contestMatchSetPointsStats?.awayScore?.current : '-' }}</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="name-player"><span class="fs-6 fw-bold">{{(contestMatchSetPointsStats?.homeTeam?.name) ? contestPlayerName(contestMatchSetPointsStats?.homeTeam?.name) : ''}}</span></td>
                                <td class="main-score-din-inside">
                                    <tr>
                                        <td *ngFor="let point of setPoints; let i=index" class="mai-table">
                                            <div class="card m-1 d-flex justify-content-center" >{{ (contestMatchSetPointsStats?.homeScore['period'+(i+1)] || contestMatchSetPointsStats?.homeScore['period'+(i+1)] >= 0) ? contestMatchSetPointsStats?.homeScore['period'+(i+1)] : '-' }}</div>
                                        </td>
                                    </tr>
                                </td>
                                
                              
                                <td style="border-left: 1px solid lightgray;">
                                    <div class="card mx-3 d-flex justify-content-center" >{{ (contestMatchSetPointsStats?.homeScore?.current || contestMatchSetPointsStats?.homeScore?.current >= 0) ? contestMatchSetPointsStats?.homeScore?.current : '-' }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row border-divider">
            <hr>
            </div>
            <div class="row">
              <div class="col-12">
                <table class="wc-table">
                    <!-- <thead>
                        <tr class="head">
                            <th colspan="3">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="table-title" style="text-align: center!important;"> 
                                            <img *ngIf="contestMatchStatistics?.player1Image" class="playerImg" src="{{contestMatchStatistics?.player1Image}}">
                                            <img *ngIf="!contestMatchStatistics?.player1Image" class="playerImg" src="https://devapi.tplsport.com:4600/uploads/images/profile.jpg">
                                            <span class="contestname">{{contestMatchStatistics?.player1Name}}</span>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="table-title" style="text-align: center!important;"> 
                                            <span class="contestname">{{contestMatchStatistics?.player2Name}}</span>
                                            <img *ngIf="contestMatchStatistics?.player2Image" class="playerImg" src="{{contestMatchStatistics?.player2Image}}">
                                            <img *ngIf="!contestMatchStatistics?.player2Image" class="playerImg" src="https://devapi.tplsport.com:4600/uploads/images/profile.jpg">
                                        </div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead> -->
                    <tbody>
                        <tr>
                            <td class="first-box">{{contestMatchStatistics?.playerOneTotalBreakPoints}}</td>
                            <td class="second-box">Break Points Won</td>
                            <td class="third-box"> {{contestMatchStatistics?.playerTwoTotalBreakPoints}}</td>
                        </tr>
                        <tr>
                            <td class="first-box">{{contestMatchStatistics?.playerOneAces}}</td>
                            <td class="second-box">Number of Aces</td>
                            <td class="third-box">{{contestMatchStatistics?.playerTwoAces}}</td>
                        </tr>
                        <tr>
                            <td class="first-box">{{contestMatchStatistics?.playerOneSetsWon}}</td>
                            <td class="second-box">Number of Sets Won</td>
                            <td class="third-box"> {{contestMatchStatistics?.playerTwoSetsWon}}</td>
                        </tr>
                        <tr>
                            <td class="first-box">{{contestMatchStatistics?.playerOneTotalGamesWon}}</td>
                            <td class="second-box">Number of Games</td>
                            <td class="third-box">{{contestMatchStatistics?.playerTwoTotalGamesWon}}</td>
                        </tr>
                        <tr>
                            <td class="first-box">{{contestMatchStatistics?.totalPlayerOnePoints}}</td>
                            <td class="second-box">Total Points Won</td>
                            <td class="third-box"> {{contestMatchStatistics?.totalPlayerTwoPoints}}</td>
                        </tr>
                        <tr *ngIf="contestMatchStatistics?.newContest">
                            <td class="first-box">{{contestMatchStatistics?.playerOneServicePoints}}</td>
                            <td class="second-box">Service Points Won</td>
                            <td class="third-box"> {{contestMatchStatistics?.playerTwoServicePoints}}</td>
                        </tr>
                    </tbody>
                </table>
              </div>
            </div>
          </div>
    </div>
</div>

</div>
